import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["promptThread"];
import I18n from 'I18n';
import { getCopilotActionFromContentAssistantData, getIntentSpecificContext } from 'copilot-plugins/utils/contentAssistantUtils';
import { getContentLangauge, getContextFromTinymceForCommand, getBrandVoiceOptionsForCommand, triggerFileManagerImageGeneration } from 'tinymce-plugins/hscopilotcollaboration/utils';

// @temporary Remove string type once all consumers have been updated
// @expiration 2025-04-15
// @deprecated
export function handleSlashOrHighlightCommand(editor, command, commandType, currentContextRef, sendActionFromAppToCopilot) {
  // Handle AI image gen command that doesn't go to copilot
  if ('id' in command && command.id === 'generateimage') {
    triggerFileManagerImageGeneration(editor);
    return;
  }
  const contentLanguage = getContentLangauge(editor);
  const {
    currentSelection,
    hasSelection,
    editorContext,
    precedingText,
    followingText
  } = getContextFromTinymceForCommand(editor, command, commandType);
  const brandVoiceOptions = getBrandVoiceOptionsForCommand(editor, command);
  forwardCommandToCopilot(command, editorContext, hasSelection, currentSelection, precedingText, followingText, currentContextRef, sendActionFromAppToCopilot, brandVoiceOptions, contentLanguage);
}
export function forwardCommandToCopilot(command, editorContext, hasSelection, currentSelection, precedingText, followingText, currentContextRef, sendActionFromAppToCopilot, brandVoiceOptions, contentLanguage) {
  const contentAssistantData = {
    commandId: command.commandId || command.id,
    parameters: formatParameters(command.parameters),
    editorContext,
    selectedText: hasSelection ? currentSelection : '',
    precedingText,
    followingText,
    brandVoiceOptions,
    contentLanguage
  };
  const collaborationContext = getIntentSpecificContext({
    editorText: contentAssistantData.editorContext,
    precedingText: contentAssistantData.precedingText,
    followingText: contentAssistantData.followingText,
    text: contentAssistantData.selectedText,
    contentLanguage: contentAssistantData.contentLanguage || 'en'
  });
  currentContextRef.current = collaborationContext;

  // Action type is FREE_FORM_INPUT for freeform prompt input in slash or highlight commands and is not needed otherwise
  const actionType = command && command.messageText ? 'FREE_FORM_INPUT' : undefined;
  const messageAction = getCopilotActionFromContentAssistantData({
    messageText: command === null || command === void 0 ? void 0 : command.messageText,
    contentAssistantData,
    actionType
  });
  sendActionFromAppToCopilot(messageAction);
}
function formatParameters(parameters) {
  const _ref = parameters !== null && parameters !== void 0 ? parameters : {},
    {
      promptThread
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({}, rest, {
    promptThread: promptThread ? I18n.text(promptThread) : ''
  });
}